import moment from "moment";
import React, { useEffect, useState } from "react";
import Select, { OptionTypeBase, components } from "react-select";
import { capitalizeFirstLetterPerWord } from "../../services/Helper";
import DateRangePicker, { DateRange } from "../common/DateRangePicker";
import LineChart from "../dashboard/LineChart";
import { 
    FaRegCalendarAlt,
    FaRegClock,
 } from "react-icons/fa";

const tabs: { key: CriticalMeasurements; label: string }[] = [
    { key: 'temperature', label: 'Temperature' },
    { key: 'pressure', label: 'Pressure' },
    { key: 'level', label: 'Level' },
    { key: 'volume', label: 'Volume' },
    { key: 'weight', label: 'Weight' },
];

interface ChartData {
    timeNo: number | string;
    value: number;
}
interface CriticalMeasurementChartData {
    temperature: ChartData[];
    pressure: ChartData[];
    level: ChartData[];
    volume: ChartData[];
    weight: ChartData[];
}
interface IProps {
    data: CriticalMeasurementChartData
}

type CriticalMeasurements = 'temperature' | 'pressure' | 'level' | 'volume' | 'weight';

const INTERVALS = [1, 2, 3, 4, 6, 8, 12];
const DURATION = ['Week', 'Month', 'Year'];

const TankHistoricalChart = ({ data }: IProps) => {
    const [activeTab, setActiveTab] = useState<CriticalMeasurements>(tabs[0].key);
    const [dateRange, setDateRange] = useState<DateRange>({ startDate: moment(), endDate: moment() });
    const [interval, setInterval] = useState<OptionTypeBase>({ label: INTERVALS[0], value: INTERVALS[0] });
    const [duration, setDuration] = useState<OptionTypeBase>({ label: DURATION[0], value: DURATION[0] });

    const Control = ({ children, ...props }:any) => {
        return (
        <components.Control {...props}>
          <FaRegClock className={"select-icon"}/>Interval <span className="select-value">Every {interval.value} Hour{parseInt(interval.value)>1&&"s"}</span>{children[1]}
        </components.Control>
        );
    };
    const Control2 = ({ children, ...props }:any) => {
        return (
        <components.Control {...props}>
          <FaRegCalendarAlt className={"select-icon"}/>Duration: <span className="select-value">This {duration.value}</span>{children[1]}
        </components.Control>
        );
    };

    useEffect(() => {
        console.log('=====dateRange', dateRange);
        console.log('=====interval', interval.value);
    }, [dateRange, interval]);

    return (
        <div className="p-3 bg-white rounded-lg border" style={{borderRadius: 8}}>
            <div className="d-flex justify-content-between align-items-center">
                <div className="item-header">Historical Data</div>
                <div className="d-flex gap">
                    {tabs.map(({ key, label }) => (
                        <button
                            className={`tab ${key === activeTab ? 'active-tab' : ''}`}
                            // className={`btn border ${key === activeTab ? 'btn-primary' : ''}`}
                            onClick={() => setActiveTab(key)}
                            key={key}
                        >
                            {label}
                        </button>
                    ))}
                </div>
            </div>
            <div className="d-flex gap" style={{marginTop:24}}>
                {/* <DateRangePicker initialValues={dateRange} onChange={(dates) => setDateRange(dates)} /> */}
                <div className="d-flex justify-content-between align-items-center gap text-base">
                    <Select
                        className="text-base interval-select"
                        value={duration}
                        options={DURATION.map(
                            item => ({ label: item, value: item })
                        )}
                        components={{ Control:Control2 }}
                        onChange={(e) => setDuration(e)}
                    />
                </div>
                <div className="d-flex justify-content-between align-items-center gap text-base mx-2">
                    <Select
                        className="text-base interval-select"
                        value={interval}
                        options={INTERVALS.map(
                            item => ({ label: item, value: item })
                        )}
                        components={{ Control }}
                        onChange={(e) => setInterval(e)}
                    />
                </div>
            </div>
            <LineChart
                height={350}
                averageName={capitalizeFirstLetterPerWord(activeTab)}
                categories={data[activeTab].map(({ timeNo }) => moment(new Date(timeNo)).format("MM/DD/YY hh:mm A"))}
                data={data[activeTab].map(({ value }) => value)}
                xTitle="Timestamp"
                xLabelRotate={-65}
                yTitle="Gauge"
            />
        </div>
    )
};

export default TankHistoricalChart;
